"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.simpleDecrypt = exports.simpleEncrypt = exports.parseUrlByEnv = exports.decrypt = exports.encrypt = exports.sha256 = exports.parseTriangle = exports.parseNumberByComma = exports.loadImg = exports.colorChange = exports.formatStyle = exports.RegExpRule = void 0;
const crypto_js_1 = __importDefault(require("crypto-js"));
const complex_utils_1 = require("complex-utils");
exports.RegExpRule = {
    mobilePhone: /^1(3|4|5|6|7|8|9)\d{9}$/,
    linePhone: /^([0-9]{3,4}-)?[0-9]{7,8}$/,
    identityCard: /^[1-9]\d{5}(18|19|20|21)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X|x)$/,
    unifiedSocialCreditCode: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/
};
const formatStyle = function (num, unit = 'vw') {
    return num + 'px';
};
exports.formatStyle = formatStyle;
function colorChange(originColor, opacity = 1) {
    originColor = originColor.toLowerCase();
    let color = 'rgba(';
    for (let i = 1; i < 7; i += 2) {
        color += (parseInt('0x' + originColor.slice(i, i + 2)) + ',');
    }
    color += opacity + ')';
    return color;
}
exports.colorChange = colorChange;
function loadImg(src, next) {
    const img = new Image();
    img.onload = function () {
        next(true);
    };
    img.onerror = function () {
        next(false);
    };
    img.src = src;
}
exports.loadImg = loadImg;
function parseNumberByComma(data, comma, decimal, list) {
    let decimalStr = '';
    if (decimal) {
        let decimalData = 0;
        [data, decimalData] = (0, complex_utils_1.parseNum)(data);
        if (decimalData) {
            decimalStr = decimalData.toString().slice(1);
        }
    }
    if (typeof data === 'number') {
        data = data.toString();
    }
    const strList = data.split('');
    if (comma) {
        for (let i = strList.length - 3; i > 0; i = i - 3) {
            strList.splice(i, 0, comma);
        }
    }
    if (list) {
        return decimalStr ? strList.concat(decimalStr.split('')) : strList;
    }
    else {
        return decimalStr ? strList.join('') + decimalStr : strList.join('');
    }
}
exports.parseNumberByComma = parseNumberByComma;
const parseTriangle = function (angle, long) {
    const radian = ((2 * Math.PI) / 360) * angle;
    return {
        x: Math.sin(radian) * long,
        y: Math.cos(radian) * long
    };
};
exports.parseTriangle = parseTriangle;
// 加密
const sha256 = function (word) {
    return crypto_js_1.default.SHA256(word).toString(crypto_js_1.default.enc.Hex);
};
exports.sha256 = sha256;
// 加密
const encrypt = function (word, keyStr = 'abcdsxyzhkj12345') {
    const key = crypto_js_1.default.enc.Utf8.parse(keyStr);
    const srcs = crypto_js_1.default.enc.Utf8.parse(word);
    const encrypted = crypto_js_1.default.AES.encrypt(srcs, key, { mode: crypto_js_1.default.mode.ECB, padding: crypto_js_1.default.pad.Pkcs7 });
    return encrypted.toString();
};
exports.encrypt = encrypt;
// 解密
const decrypt = function (word, keyStr = 'abcdsxyzhkj12345') {
    keyStr = keyStr || 'abcdsxyzhkj12345';
    const key = crypto_js_1.default.enc.Utf8.parse(keyStr);
    const decrypt = crypto_js_1.default.AES.decrypt(word, key, { mode: crypto_js_1.default.mode.ECB, padding: crypto_js_1.default.pad.Pkcs7 });
    return crypto_js_1.default.enc.Utf8.stringify(decrypt).toString();
};
exports.decrypt = decrypt;
const parseUrlByEnv = function (url, envStr = '{ENV}') {
    const env = (0, complex_utils_1.getEnvMode)();
    return url.replace(envStr, env === 'test' ? '-test' : env === 'dev' ? '-dev' : '');
};
exports.parseUrlByEnv = parseUrlByEnv;
// 简易加密
const simpleEncrypt = function (text) {
    return btoa(text);
};
exports.simpleEncrypt = simpleEncrypt;
// 建议解密
const simpleDecrypt = function (encryptedText) {
    return atob(encryptedText);
};
exports.simpleDecrypt = simpleDecrypt;
